import { environment } from '../../environment';
import { HttpStatusCodes } from '../../../utils/http/HttpConstants';
import { AuthChoice } from '../data/AuthChoice';
import { GenericRequest, HTTPFetchResponse } from '../data/AuthTypes';
import { config } from '../../../auth/AuthConfig';
import { AnalyticsEvent, EventType } from '../../Events/EventTypes';
import { v4 } from 'uuid';

export enum AuthenticateError {
	// the user pressed the cancel button in a logon dialog
	CancelledByUser,
	// the protocol could not be used (e.g. IWA fails due to being disabled)
	UnsuitableProtocol,
}

export interface Authenticator {
	getToken(
		authProtocol: AuthChoice,
		authProtocolsRequest: GenericRequest,
		id: string,
		referenceUri: string,
		transactionId: string
	): Promise<HTTPFetchResponse | AuthenticateError>;
}

export function isTokenResponse(
	response: HTTPFetchResponse | AuthenticateError
): response is HTTPFetchResponse {
	return (response as HTTPFetchResponse).statusCode === HttpStatusCodes.HTTP_STATUS_OK;
}

export const analyticsConstants = {
	CATEGORY_AUTHMANAGER: 'authmanager',
	ACTION_AUTHENTICATOR_PROTOCOL: 'authenticator_protocol',
	LABEL_INTEGRATEDWINDOWS_AUTHENTICATOR: 'cintegratedwindows_authenticator',
	LABEL_AGSSO_ADV_AUTHENTICATOR: 'cagsso_adv_authenticator',
	LABEL_AGSSO_ADVNOPWD_AUTHENTICATOR: 'cagsso_advNoPwd_authenticator',
	LABEL_AGSSO_BASIC_AUTHENTICATOR: 'cagsso_basic_authenticator',
	LABEL_AGSSO_BASICNOPWD_AUTHENTICATOR: 'cagsso_basicNoPwd_authenticator',
	LABEL_CLIENTCERTIFICATEAUTHIMPL: 'cclientcertificate_auth',
	LABEL_AGLEGACYCERTAUTHIMPL: 'caglegacycert_auth',
	LABEL_DSFORMSAUTHIMPL: 'cdsforms_auth',
	LABEL_DSFORMSVARIANTAUTHIMPL: 'cdsformsvariant_auth',
	LABEL_HTTPBASICAUTHENTICATOR: 'chttpbasic_authenticator',
	CUSTOM_DIMENSION_AUTHENTICATIONSDKTYPE: 'authenticationsdktype',
	CUSTOM_DIMENSION_CLIENT_TYPE: 'client_type',
	VALUE_AUTHENTICATIONSDK_LITEVERSION: 'authmanlite',
};

export function logEvent(label: string, value: number): void {
	const analyticsEvent: AnalyticsEvent = {
		id: v4(),
		type: EventType.ANALYTICS_TRACKING_EVENT,
		payload: {
			category: analyticsConstants.CATEGORY_AUTHMANAGER,
			action: analyticsConstants.ACTION_AUTHENTICATOR_PROTOCOL,
			label,
			value,
			properties: [
				{
					propertyName: analyticsConstants.CUSTOM_DIMENSION_AUTHENTICATIONSDKTYPE,
					propertyValue: analyticsConstants.VALUE_AUTHENTICATIONSDK_LITEVERSION,
				},
				{
					propertyName: analyticsConstants.CUSTOM_DIMENSION_CLIENT_TYPE,
					propertyValue: `${config.platform ?? ''} ${config.hostApp ?? ''}`,
				},
			],
		},
	};
	environment.sendEventToNative(analyticsEvent);
}
